import type { FormHiddenFieldGroup } from '@seek/cmsu-cms-connect';

/** isolated hidden field rendering
 *
 */
export const RenderHiddenField = ({
  field,
}: {
  field: FormHiddenFieldGroup;
}) => (
  <>
    {field.keyValues.map((keyValue) => (
      <input
        type="hidden"
        key={keyValue.key}
        id={keyValue.key}
        value={keyValue.value}
        style={{ display: 'none' }}
      />
    ))}
  </>
);
